export default "/images/framework/ChallengeAgainEng.482dfebf.svg?482dfebf";